
/**
* Form Class
*
* This class handles submissions from forms and passes the data to the PHP class
*
* @package  Manco Automatics
* @author   Tom Kellock
* @access   public
*/
class Form
{
  /**
  * Constructor function
  *
  * Function that performs actions upon initiation of this class
  *
  * @param    array  form   The form element
  * @return   void
  * @access   public
  */
  constructor(form)
  {
    this.form = form;

    this.genericError = {
      has_errors: true,
      title:      'Sorry',
      message:    'Something went wrong. Please try again or contact us for assistance.',
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      this._submit();
    });
  }

  _submit()
  {
    /* eslint-disable */
    const request  = new XMLHttpRequest();
    const formData = new FormData(this.form);
    const token    = scriptVars.token;
    const ajaxUrl  = scriptVars.ajaxUrl;
    const url      = ajaxUrl + '?action=submit_form';
    const formId   = this.form.dataset.id;
    const _self    = this;
    /* eslint-enable */

    formData.append('form_id', formId);
    formData.append('token', token);
    formData.append('form_type', 'contact');

    request.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {

        // uncomment this to show debug in console
        // console.log(this.responseText);

        let response = JSON.parse(this.responseText);

        if (!response) {
          response = this.genericError;
        }

        _self._validate(response);

      } else if (this.readyState == 4 && this.status != 200) {
        _self._validate(this.genericError);
      }
    }

    request.open('POST', url);
    request.send(formData);
  }

  _validate(response)
  {
    let inputErrors = this.form.querySelectorAll('.form--error');

    inputErrors.forEach((input) => {
      if (!input.classList.contains('d-none')) {
        input.classList.add('d-none');
      }
    });

    if (response.has_errors) {
      for (let i = 0; i < response.errors.length; i++) {
        let error     = response.errors[i];
        let group     = this.form.querySelector('#' + error.name);
        let errorDiv  = group.querySelector('.form--error');

        errorDiv.classList.remove('d-none');
        errorDiv.innerHTML = error.message;
      }
    } else if (response.redirect) {
      let url = response.redirect_page;

      if ('forward_data_field_data' in response) {
        let query = '?' + response.forward_data_field_name + '=' + response.forward_data_field_data;
        url += query;
      }

      window.location.replace(url);

    } else {
      let errorDiv = document.createElement('div');

      errorDiv.innerHTML = this.genericError;
      this.form.appendChild(errorDiv);
    }
  }
}

export default Form;
